<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-form v-if="languagesCount()"
              ref="form"
              autocomplete="off"
              method="post"
              action=""
      >
        <v-row class="pa-3">
          <v-card class="ma-3 w-100">
            <v-card-title class="headline">{{ $t('announcement.title') }}</v-card-title>
            <v-col v-for="(item, index) in sendParams.title_translation" :key="'title'+index"
                   cols="12">
              <v-text-field
                v-model="sendParams.title_translation[index]"
                :counter="50"
                :rules="[rules.required, rules.max(50)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="$t('announcement.title')+' ('+ index +')'"
                autocomplete="off"
                :error-messages="(errors && errors[`title_translation.${index}`]) ? $t('announcement.error_field') : null"
                @input="removeError(`title_translation.${index}`)"
              ></v-text-field>
            </v-col>
          </v-card>
          <v-card class="ma-3 w-100">
            <v-card-title class="headline">{{ $t('announcement.desc') }} ({{ $t('announcement.can_be_empty') }})</v-card-title>
            <v-col v-for="(item, index) in sendParams.excerpt_translation" :key="'excerpt'+index"
                   cols="12">
              <v-text-field
                v-model="sendParams.excerpt_translation[index]"
                :counter="100"
                :rules="[rules.max(100)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="$t('announcement.desc')+' ('+ index +')'"
                autocomplete="off"
                :error-messages="(errors && errors[`excerpt_translation.${index}`]) ? $t('announcement.error_field') : null"
                @input="removeError(`excerpt_translation.${index}`)"
              ></v-text-field>
            </v-col>
          </v-card>
          <v-card class="ma-3 w-100">
            <v-card-title class="headline">{{ $t('announcement.message') }}</v-card-title>
            <v-col v-for="(item, index) in sendParams.body_translation" :key="'body'+index"
                   cols="12">
              <v-textarea
                v-model="sendParams.body_translation[index]"
                :counter="3000"
                :rules="[rules.required, rules.max(3000)]"
                prepend-icon="mdi-account-badge-horizontal-outline"
                :label="$t('announcement.message')+' ('+ index +')'"
                autocomplete="off"
                :error-messages="(errors && errors[`body_translation.${index}`]) ? $t('announcement.error_field') : null"
                @input="removeError(`body_translation.${index}`)"
              ></v-textarea>
            </v-col>
          </v-card>
          <v-col
            cols="12"
            md="6">
            <v-select
              v-model="sendParams.role"
              :hint="lang($store, 'sap/listings.global.filter.hints.role')"
              :items="rolesItems"
              persistent-hint
              single-line
              :loading="false"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
            style="text-align: right"
          >
            <v-btn @click.prevent="onSend" color="primary">{{ $t('actions.send') }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <p v-else class="text-center pa-3">
        <v-icon>mdi-account-badge-outline</v-icon>
        <b>{{ $t('announcement.error') }}</b>
        <v-icon>mdi-account-badge-outline</v-icon>
      </p>
    </v-card>
  </v-container>
</template>

<script>
import { CLEANERS } from '@/constants/roles';
import validationMixin from '@/mixins/validationMixin';
import NotificationProxy from '@/proxies/Notifications/NotificationProxy';
import { LANGUAGES } from '~constants/notification_languages';
import { prepareValidationMessages } from '@/utils';

export default {
  name: 'SendAnnouncement',
  mixins: [
    validationMixin,
  ],
  data() {
    return {
      isComponentLoading: false,
      errors: {},
      sendParams: {
        role: null,
        title: '',
        body: '',
        excerpt: '',
        title_translation: {},
        excerpt_translation: {},
        body_translation: {},
      },
    };
  },
  computed: {
    rolesItems() {
      return [
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.all'),
          value: null,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.foreman'),
          value: CLEANERS.FOREMAN,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.cleaner_base'),
          value: CLEANERS.CLEANER_BASE,
        },
        {
          text: this.lang(this.$store, 'sap/listings.global.filter.roles.cleaner_complex'),
          value: CLEANERS.CLEANER_COMPLEX,
        },
      ];
    },
  },
  mounted() {
    this.initParams();
  },
  methods: {
    initParams() {
      this.sendParams.title_translation = {};
      this.sendParams.excerpt_translation = {};
      this.sendParams.body_translation = {};
      Object.keys(LANGUAGES)
        .forEach((key) => {
          this.sendParams.title_translation[key] = '';
          this.sendParams.excerpt_translation[key] = '';
          this.sendParams.body_translation[key] = '';
        });

      this.sendParams.role = null;
      this.sendParams.title = '';
      this.sendParams.body = '';
      this.sendParams.excerpt = '';
    },
    languagesCount() {
      return Object.keys(LANGUAGES).length;
    },
    onSend() {
      if (this.$refs.form.validate()) {
        this.isComponentLoading = true;
        const data = {
          role: this.sendParams.role,
          title_translation: this.sendParams.title_translation,
          excerpt_translation: this.sendParams.excerpt_translation,
          body_translation: this.sendParams.body_translation,
        };
        if (!this.sendParams.role) {
          data.roles = Object.values(CLEANERS);
        }
        new NotificationProxy().sendAnnouncement(data)
          .then(() => {
            this.$store.dispatch('page/displaySnackbar', {
              text: 'Сообщение отправлено в обработку',
            });
            this.initParams();
          })
          .catch((response) => {
            console.log(response);
            let text = 'Ошибка при отправке запроса';
            if (response && response.status === 422) {
              text = 'Ошибка заполнения полей';
              this.errors = prepareValidationMessages(response.data.data);
            }
            setTimeout(() => {
              this.$store.dispatch('page/displaySnackbar', {
                text: text,
                color: 'red darken-3',
                timeout: 6000,
              });
            }, 500);
          })
          .finally(() => {
            this.isComponentLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
